// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/unified-fields/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        readiness: build.query<ReadinessApiResponse, ReadinessApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        liveness: build.query<LivenessApiResponse, LivenessApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        listFields: build.query<ListFieldsApiResponse, ListFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields`,
                params: {
                    page: queryArg.page,
                    filter: queryArg.filter,
                    sort: queryArg.sort,
                    include: queryArg.include,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createField: build.mutation<CreateFieldApiResponse, CreateFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields`,
                method: "POST",
                body: queryArg.createFieldRequest,
                params: { with_cdif: queryArg.withCdif },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        validateFields: build.mutation<ValidateFieldsApiResponse, ValidateFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields/validate`,
                method: "POST",
                body: queryArg.validateBatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateField: build.mutation<UpdateFieldApiResponse, UpdateFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields/${queryArg.fieldId}`,
                method: "PATCH",
                body: queryArg.updateFieldRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteField: build.mutation<DeleteFieldApiResponse, DeleteFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields/${queryArg.fieldId}`,
                method: "DELETE",
                body: queryArg.deleteFieldRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        addIntegrationMapping: build.mutation<AddIntegrationMappingApiResponse, AddIntegrationMappingApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields/${queryArg.fieldId}/integration_mappings`,
                method: "POST",
                body: queryArg.addIntegrationFieldMappingRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        removeIntegrationMapping: build.mutation<RemoveIntegrationMappingApiResponse, RemoveIntegrationMappingApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client_fields/${queryArg.fieldId}/integration_mappings`,
                method: "DELETE",
                params: {
                    namespace: queryArg["namespace"],
                    integration_key: queryArg.integrationKey,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createOptionSet: build.mutation<CreateOptionSetApiResponse, CreateOptionSetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/option_sets`,
                method: "POST",
                body: queryArg.createOptionSetRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteOptionSet: build.mutation<DeleteOptionSetApiResponse, DeleteOptionSetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/option_sets/${queryArg.optionSetId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listFieldOptions: build.query<ListFieldOptionsApiResponse, ListFieldOptionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_options`,
                params: { page: queryArg.page, filter: queryArg.filter },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFieldOptions: build.mutation<CreateFieldOptionsApiResponse, CreateFieldOptionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_options`,
                method: "POST",
                body: queryArg.createFieldOptionsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteFieldOptions: build.mutation<DeleteFieldOptionsApiResponse, DeleteFieldOptionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_options`,
                method: "DELETE",
                body: queryArg.deleteFieldOptionsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateFieldOption: build.mutation<UpdateFieldOptionApiResponse, UpdateFieldOptionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_options/${queryArg.optionId}`,
                method: "PATCH",
                body: queryArg.updateFieldOptionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFieldSuggestions: build.query<GetFieldSuggestionsApiResponse, GetFieldSuggestionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_suggestions`,
                params: { filter: queryArg.filter, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listFieldSections: build.query<ListFieldSectionsApiResponse, ListFieldSectionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections`,
                params: {
                    filter: queryArg.filter,
                    page: queryArg.page,
                    include: queryArg.include,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFieldSection: build.mutation<CreateFieldSectionApiResponse, CreateFieldSectionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections`,
                method: "POST",
                body: queryArg.createFieldSectionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFieldSection: build.query<GetFieldSectionApiResponse, GetFieldSectionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/${queryArg.sectionId}`,
                params: { include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateFieldSection: build.mutation<UpdateFieldSectionApiResponse, UpdateFieldSectionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/${queryArg.sectionId}`,
                method: "PATCH",
                body: queryArg.updateFieldSectionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteFieldSection: build.mutation<DeleteFieldSectionApiResponse, DeleteFieldSectionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/${queryArg.sectionId}`,
                method: "DELETE",
                body: queryArg.deleteFieldSectionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reorderFieldSections: build.mutation<ReorderFieldSectionsApiResponse, ReorderFieldSectionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/reorder-sections`,
                method: "POST",
                body: queryArg.reorderFieldSectionsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        moveSectionFields: build.mutation<MoveSectionFieldsApiResponse, MoveSectionFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/move-fields`,
                method: "POST",
                body: queryArg.moveFieldSectionFieldsRequest,
                params: { field_section_id: queryArg.fieldSectionId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reorderSectionFields: build.mutation<ReorderSectionFieldsApiResponse, ReorderSectionFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_sections/reorder-fields`,
                method: "POST",
                body: queryArg.reorderFieldSectionFieldsRequest,
                params: { field_section_id: queryArg.fieldSectionId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listFieldLookupTableColumns: build.query<ListFieldLookupTableColumnsApiResponse, ListFieldLookupTableColumnsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns`,
                params: {
                    filter: queryArg.filter,
                    page: queryArg.page,
                    include_client_field: queryArg.includeClientField,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFieldLookupTableColumns: build.mutation<CreateFieldLookupTableColumnsApiResponse, CreateFieldLookupTableColumnsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns`,
                method: "POST",
                body: queryArg.createFieldLookupTableColumnsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFieldLookupTableColumn: build.query<GetFieldLookupTableColumnApiResponse, GetFieldLookupTableColumnApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns/${queryArg.columnId}`,
                params: { include_client_field: queryArg.includeClientField },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateLookupTableColumn: build.mutation<UpdateLookupTableColumnApiResponse, UpdateLookupTableColumnApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns/${queryArg.columnId}`,
                method: "PATCH",
                body: queryArg.updateFieldLookupTableColumnRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteLookupTableColumn: build.mutation<DeleteLookupTableColumnApiResponse, DeleteLookupTableColumnApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns/${queryArg.columnId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listFieldLookupTableRows: build.query<ListFieldLookupTableRowsApiResponse, ListFieldLookupTableRowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows`,
                params: {
                    filter: queryArg.filter,
                    page: queryArg.page,
                    sort: queryArg.sort,
                    fields: queryArg.fields,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFieldLookupTableRows: build.mutation<CreateFieldLookupTableRowsApiResponse, CreateFieldLookupTableRowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows`,
                method: "POST",
                body: queryArg.createFieldLookupTableRowsRequest,
                params: { field_lookup_table_id: queryArg.fieldLookupTableId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFieldLookupTableRow: build.query<GetFieldLookupTableRowApiResponse, GetFieldLookupTableRowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows/${queryArg.rowId}`,
                params: { fields: queryArg.fields },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateLookupTableRow: build.mutation<UpdateLookupTableRowApiResponse, UpdateLookupTableRowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows/${queryArg.rowId}`,
                method: "PATCH",
                body: queryArg.updateFieldLookupTableRowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteLookupTableRow: build.mutation<DeleteLookupTableRowApiResponse, DeleteLookupTableRowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows/${queryArg.rowId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getFieldLookupTableCell: build.query<GetFieldLookupTableCellApiResponse, GetFieldLookupTableCellApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_cells/${queryArg.cellId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateLookupTableCell: build.mutation<UpdateLookupTableCellApiResponse, UpdateLookupTableCellApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_cells/${queryArg.cellId}`,
                method: "PATCH",
                body: queryArg.updateFieldLookupTableCellRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        clearLookupTableCell: build.mutation<ClearLookupTableCellApiResponse, ClearLookupTableCellApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_cells/${queryArg.cellId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listLookupTables: build.query<ListLookupTablesApiResponse, ListLookupTablesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_tables`,
                params: {
                    page: queryArg.page,
                    filter: queryArg.filter,
                    include_columns: queryArg.includeColumns,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFieldLookupTable: build.mutation<CreateFieldLookupTableApiResponse, CreateFieldLookupTableApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_tables`,
                method: "POST",
                body: queryArg.createFieldLookupTableRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getLookupTable: build.query<GetLookupTableApiResponse, GetLookupTableApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_tables/${queryArg.tableId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateLookupTable: build.mutation<UpdateLookupTableApiResponse, UpdateLookupTableApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_tables/${queryArg.tableId}`,
                method: "PATCH",
                body: queryArg.updateFieldLookupTableRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteLookupTable: build.mutation<DeleteLookupTableApiResponse, DeleteLookupTableApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_tables/${queryArg.tableId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reorderLookupTableColumns: build.mutation<ReorderLookupTableColumnsApiResponse, ReorderLookupTableColumnsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_columns/reorder`,
                method: "POST",
                body: queryArg.reorderFieldLookupTableColumnsRequest,
                params: { field_lookup_table_id: queryArg.fieldLookupTableId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reorderLookupTableRows: build.mutation<ReorderLookupTableRowsApiResponse, ReorderLookupTableRowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows/reorder`,
                method: "POST",
                body: queryArg.reorderFieldLookupTableRowsRequest,
                params: { field_lookup_table_id: queryArg.fieldLookupTableId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        bulkUpsertLookupTableRows: build.mutation<BulkUpsertLookupTableRowsApiResponse, BulkUpsertLookupTableRowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/field_lookup_table_rows/bulk-upsert`,
                method: "POST",
                body: queryArg.bulkUpsertFieldLookupTableRowsRequest,
                params: { field_lookup_table_id: queryArg.fieldLookupTableId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReadinessApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type ReadinessApiArg = void;
export type LivenessApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type LivenessApiArg = void;
export type ListFieldsApiResponse = 
/** status 200 Successful Response */ JsonApiPaginatedResponseUnionClientFieldResourceClientFieldRelatedResourceFieldSectionResource;
export type ListFieldsApiArg = {
    page?: {
        offset?: number;
        limit?: number;
    };
    filter?: {
        id?: string | null;
        active?: boolean | null;
        api_name?: string | null;
        namespace?: string | null;
        integration_key?: string | null;
        search_query?: string | null;
        field_section_id?: string | null;
        contract_type?: string | null;
    };
    sort?: string | null;
    include?: string | null;
};
export type CreateFieldApiResponse = 
/** status 201 Successful Response */ JsonApiPaginatedResponseUnionClientFieldResourceClientFieldRelatedResourceFieldSectionResource;
export type CreateFieldApiArg = {
    /** When true, synchronously project the created field's CDIF via Pilot and return its ``cdif_id`` / ``cdif_status`` in the item's ``meta``. Requires exactly one field in ``data``. When false (default), the CDIF is still created, but asynchronously by the outbox consumer, and is not returned. */
    withCdif?: boolean;
    createFieldRequest: CreateFieldRequest;
};
export type ValidateFieldsApiResponse = 
/** status 207 Successful Response */ ValidateBatchResponse;
export type ValidateFieldsApiArg = {
    validateBatchRequest: ValidateBatchRequest;
};
export type UpdateFieldApiResponse = 
/** status 200 Successful Response */ JsonApiResponseClientFieldResourceJsonApiResource;
export type UpdateFieldApiArg = {
    fieldId: string;
    updateFieldRequest: UpdateFieldRequest;
};
export type DeleteFieldApiResponse = void;
export type DeleteFieldApiArg = {
    fieldId: string;
    deleteFieldRequest: DeleteFieldRequest;
};
export type AddIntegrationMappingApiResponse = 
/** status 201 Successful Response */ JsonApiResponseIntegrationFieldMappingResourceJsonApiResource;
export type AddIntegrationMappingApiArg = {
    fieldId: string;
    addIntegrationFieldMappingRequest: AddIntegrationFieldMappingRequest;
};
export type RemoveIntegrationMappingApiResponse = 
/** status 204 Successful Response */ void;
export type RemoveIntegrationMappingApiArg = {
    fieldId: string;
    /** Integration namespace of the mapping to remove. */
    namespace: string;
    /** Integration key of the mapping to remove. Required, and together with `namespace` it matches the unique index, so the request can only ever remove one mapping. */
    integrationKey: string;
};
export type CreateOptionSetApiResponse = 
/** status 201 Successful Response */ JsonApiResponseOptionSetResourceJsonApiResource;
export type CreateOptionSetApiArg = {
    createOptionSetRequest: CreateOptionSetRequest;
};
export type DeleteOptionSetApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteOptionSetApiArg = {
    optionSetId: string;
};
export type ListFieldOptionsApiResponse = 
/** status 200 Successful Response */ JsonApiPaginatedResponseFieldOptionResourceJsonApiResource;
export type ListFieldOptionsApiArg = {
    page?: {
        offset?: number;
        limit?: number;
    };
    filter?: {
        option_set_id?: string | null;
        search?: string | null;
    };
};
export type CreateFieldOptionsApiResponse = 
/** status 201 Successful Response */ CreateFieldOptionsResponse;
export type CreateFieldOptionsApiArg = {
    createFieldOptionsRequest: CreateFieldOptionsRequest;
};
export type DeleteFieldOptionsApiResponse = 
/** status 204 Successful response with an empty body. No deletion count or per-id status is returned; deletes are idempotent. */ void;
export type DeleteFieldOptionsApiArg = {
    deleteFieldOptionsRequest: DeleteFieldOptionsRequest;
};
export type UpdateFieldOptionApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldOptionResourceJsonApiResource;
export type UpdateFieldOptionApiArg = {
    optionId: string;
    updateFieldOptionRequest: UpdateFieldOptionRequest;
};
export type GetFieldSuggestionsApiResponse = 
/** status 200 Successful Response */ FieldSuggestionsResponse;
export type GetFieldSuggestionsApiArg = {
    filter?: {
        field_id?: string;
        query?: string;
    };
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type ListFieldSectionsApiResponse = 
/** status 200 Successful Response */ JsonApiPaginatedResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource;
export type ListFieldSectionsApiArg = {
    filter?: {
        id?: string | null;
    };
    page?: {
        offset?: number;
        limit?: number;
    };
    include?: string | null;
};
export type CreateFieldSectionApiResponse = 
/** status 201 Successful Response */ JsonApiResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource;
export type CreateFieldSectionApiArg = {
    createFieldSectionRequest: CreateFieldSectionRequest;
};
export type GetFieldSectionApiResponse = 
/** status 200 Successful Response */ JsonApiResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource;
export type GetFieldSectionApiArg = {
    sectionId: string;
    include?: string | null;
};
export type UpdateFieldSectionApiResponse = 
/** status 200 Successful Response */ JsonApiResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource;
export type UpdateFieldSectionApiArg = {
    sectionId: string;
    updateFieldSectionRequest: UpdateFieldSectionRequest;
};
export type DeleteFieldSectionApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteFieldSectionApiArg = {
    sectionId: string;
    deleteFieldSectionRequest: DeleteFieldSectionRequest;
};
export type ReorderFieldSectionsApiResponse = 
/** status 204 Successful Response */ void;
export type ReorderFieldSectionsApiArg = {
    reorderFieldSectionsRequest: ReorderFieldSectionsRequest;
};
export type MoveSectionFieldsApiResponse = 
/** status 204 Successful Response */ void;
export type MoveSectionFieldsApiArg = {
    fieldSectionId?: string | null;
    moveFieldSectionFieldsRequest: MoveFieldSectionFieldsRequest;
};
export type ReorderSectionFieldsApiResponse = 
/** status 204 Successful Response */ void;
export type ReorderSectionFieldsApiArg = {
    fieldSectionId?: string | null;
    reorderFieldSectionFieldsRequest: ReorderFieldSectionFieldsRequest;
};
export type ListFieldLookupTableColumnsApiResponse = 
/** status 200 Successful Response */ JsonApiPaginatedResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource;
export type ListFieldLookupTableColumnsApiArg = {
    filter?: {
        column_id?: string | null;
        field_lookup_table_id?: string | null;
    };
    page?: {
        offset?: number;
        limit?: number;
    };
    includeClientField?: boolean;
};
export type CreateFieldLookupTableColumnsApiResponse = 
/** status 201 Successful Response */ JsonApiPaginatedResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource;
export type CreateFieldLookupTableColumnsApiArg = {
    createFieldLookupTableColumnsRequest: CreateFieldLookupTableColumnsRequest;
};
export type GetFieldLookupTableColumnApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource;
export type GetFieldLookupTableColumnApiArg = {
    columnId: string;
    includeClientField?: boolean;
};
export type UpdateLookupTableColumnApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource;
export type UpdateLookupTableColumnApiArg = {
    columnId: string;
    updateFieldLookupTableColumnRequest: UpdateFieldLookupTableColumnRequest;
};
export type DeleteLookupTableColumnApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteLookupTableColumnApiArg = {
    columnId: string;
};
export type ListFieldLookupTableRowsApiResponse = 
/** status 200 Paginated rows; each row includes a cell map keyed by column key. */ JsonApiPaginatedResponseFieldLookupTableRowResourceFieldLookupTableCellResource;
export type ListFieldLookupTableRowsApiArg = {
    filter?: {
        field_lookup_table_id?: string | null;
        row_id?: string | null;
        reference_value?: string | null;
        reference_match?: string;
    };
    page?: {
        offset?: number;
        limit?: number;
    };
    sort?: string | null;
    fields?: {
        cells?: string | null;
    };
};
export type CreateFieldLookupTableRowsApiResponse = 
/** status 201 Successful Response */ JsonApiPaginatedResponseFieldLookupTableRowResourceFieldLookupTableCellResource;
export type CreateFieldLookupTableRowsApiArg = {
    fieldLookupTableId: string;
    createFieldLookupTableRowsRequest: CreateFieldLookupTableRowsRequest;
};
export type GetFieldLookupTableRowApiResponse = 
/** status 200 Single row with a cell map keyed by column key (not a list). */ JsonApiResponseFieldLookupTableRowResourceFieldLookupTableCellResource;
export type GetFieldLookupTableRowApiArg = {
    rowId: string;
    fields?: {
        cells?: string | null;
    };
};
export type UpdateLookupTableRowApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableRowResourceFieldLookupTableCellResource;
export type UpdateLookupTableRowApiArg = {
    rowId: string;
    updateFieldLookupTableRowRequest: UpdateFieldLookupTableRowRequest;
};
export type DeleteLookupTableRowApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteLookupTableRowApiArg = {
    rowId: string;
};
export type GetFieldLookupTableCellApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableCellPrimaryResourceJsonApiResource;
export type GetFieldLookupTableCellApiArg = {
    cellId: string;
};
export type UpdateLookupTableCellApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableCellPrimaryResourceJsonApiResource;
export type UpdateLookupTableCellApiArg = {
    cellId: string;
    updateFieldLookupTableCellRequest: UpdateFieldLookupTableCellRequest;
};
export type ClearLookupTableCellApiResponse = 
/** status 204 Successful Response */ void;
export type ClearLookupTableCellApiArg = {
    cellId: string;
};
export type ListLookupTablesApiResponse = 
/** status 200 Successful Response */ JsonApiPaginatedResponseFieldLookupTableResourceFieldLookupTableColumnResource;
export type ListLookupTablesApiArg = {
    page?: {
        offset?: number;
        limit?: number;
    };
    filter?: {
        id?: string | null;
        active?: boolean | null;
        name?: string | null;
        reference_field_id?: string | null;
    };
    includeColumns?: boolean;
};
export type CreateFieldLookupTableApiResponse = 
/** status 201 Successful Response */ JsonApiResponseFieldLookupTableResourceJsonApiResource;
export type CreateFieldLookupTableApiArg = {
    createFieldLookupTableRequest: CreateFieldLookupTableRequest;
};
export type GetLookupTableApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableResourceJsonApiResource;
export type GetLookupTableApiArg = {
    tableId: string;
};
export type UpdateLookupTableApiResponse = 
/** status 200 Successful Response */ JsonApiResponseFieldLookupTableResourceJsonApiResource;
export type UpdateLookupTableApiArg = {
    tableId: string;
    updateFieldLookupTableRequest: UpdateFieldLookupTableRequest;
};
export type DeleteLookupTableApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteLookupTableApiArg = {
    tableId: string;
};
export type ReorderLookupTableColumnsApiResponse = 
/** status 204 Successful Response */ void;
export type ReorderLookupTableColumnsApiArg = {
    fieldLookupTableId: string;
    reorderFieldLookupTableColumnsRequest: ReorderFieldLookupTableColumnsRequest;
};
export type ReorderLookupTableRowsApiResponse = 
/** status 204 Successful Response */ void;
export type ReorderLookupTableRowsApiArg = {
    fieldLookupTableId: string;
    reorderFieldLookupTableRowsRequest: ReorderFieldLookupTableRowsRequest;
};
export type BulkUpsertLookupTableRowsApiResponse = 
/** status 200 Successful Response */ BulkUpsertRowsResponse;
export type BulkUpsertLookupTableRowsApiArg = {
    fieldLookupTableId: string;
    bulkUpsertFieldLookupTableRowsRequest: BulkUpsertFieldLookupTableRowsRequest;
};
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type LogicalType = "TEXT" | "NUMBER" | "BOOLEAN" | "DATE" | "MONETARY" | "FILE" | "REFERENCE" | "USER" | "EMAIL" | "URL" | "DEPARTMENT" | "ADDRESS" | "DURATION";
export type SearchType = "KEYWORD" | "TEXT" | "DATE" | "NUMBER" | "BOOLEAN" | "ATTACHMENT" | "REFERENCE" | "USER" | "DEPARTMENT";
export type DataClassification = "PUBLIC" | "INTERNAL" | "PII" | "CONFIDENTIAL";
export type IntegrationFieldMappingAttributes = {
    id: string;
    namespace: string;
    domain?: string | null;
    integration_key: string;
};
export type DocRestriction = "EXCLUDE" | "INCLUDE";
export type ClientFieldAttributes = {
    custom_name: string;
    description?: string | null;
    api_name?: string | null;
    logical_type: LogicalType;
    search_type: SearchType;
    deactivated_at?: string | null;
    option_set_id?: string | null;
    default_value?: {
        [key: string]: any;
    } | null;
    custom_settings: {
        [key: string]: any;
    };
    display_settings: {
        [key: string]: any;
    };
    suggestions_id?: string | null;
    suggestion_source_config?: {
        [key: string]: any;
    } | null;
    referenced_by_field_lookup_tables?: string[];
    data_classification: DataClassification;
    supports_option_set: boolean;
    is_editable: boolean;
    created_by?: number | null;
    updated_by?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    integration_field_mappings?: IntegrationFieldMappingAttributes[];
    field_section_id?: string | null;
    field_section_position?: number | null;
    doc_restriction?: DocRestriction | null;
    doc_types?: string[];
};
export type ClientFieldResourceMeta = {
    version: number;
    cdif_id?: number | null;
    cdif_status?: ("created" | "existed") | null;
};
export type ClientFieldResource = {
    type?: "client_fields";
    id: string;
    attributes: ClientFieldAttributes;
    meta?: ClientFieldResourceMeta | null;
};
export type ResourceMeta = {
    version: number;
};
export type JsonApiResourceIdentifier = {
    type: string;
    id: string;
};
export type JsonApiRelationship = {
    data?: JsonApiResourceIdentifier | JsonApiResourceIdentifier[] | null;
};
export type ClientFieldRelationships = {
    field_section: JsonApiRelationship;
};
export type ClientFieldRelatedResource = {
    type?: "client_fields";
    id: string;
    attributes: ClientFieldAttributes;
    meta?: ResourceMeta | null;
    relationships: ClientFieldRelationships;
};
export type FieldSectionAttributes = {
    name: string;
    position: number;
    created_by?: number | null;
    updated_by?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
};
export type FieldSectionResource = {
    type?: "field_sections";
    id: string;
    attributes: FieldSectionAttributes;
    meta?: ResourceMeta | null;
};
export type PaginationMeta = {
    offset: number;
    limit: number;
    total: number;
};
export type JsonApiListMeta = {
    page: PaginationMeta;
};
export type PageLinks = {
    self?: string | null;
    first?: string | null;
    prev?: string | null;
    next?: string | null;
    last?: string | null;
};
export type JsonApiPaginatedResponseUnionClientFieldResourceClientFieldRelatedResourceFieldSectionResource = {
    data: (ClientFieldResource | ClientFieldRelatedResource)[];
    included?: FieldSectionResource[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type CreateIntegrationFieldMappingAttributes = {
    namespace: string;
    integration_key: string;
    /** Optional sub-scope within `namespace`, echoed back on reads. Free-form to the service and not part of a mapping's identity, so it never distinguishes two mappings. */
    domain?: string | null;
};
export type CreateFieldAttributes = {
    custom_name: string;
    description?: string | null;
    logical_type: LogicalType;
    /** Required for TEXT, EMAIL, and URL: indexing mode in Evisearch (TEXT = ngram-style text index, KEYWORD = keyword/facet index). Omitted for other logical types — derived by the server. */
    search_type?: SearchType | null;
    data_classification: DataClassification;
    option_set_id?: string | null;
    default_value?: {
        [key: string]: any;
    } | null;
    custom_settings?: {
        [key: string]: any;
    } | null;
    display_settings?: {
        [key: string]: any;
    } | null;
    suggestions_id?: string | null;
    /** Optional suggestion-source config. When present, must include a string ``type`` field; Pilot and the UI interpret the type value. */
    suggestion_source_config?: {
        [key: string]: any;
    } | null;
    /** Restricts which document types the field applies to. ``EXCLUDE`` treats doc_types as an exclusion list; ``INCLUDE`` treats it as the sole allowed list. Omit (with an empty/omitted doc_types) to apply to all document types. */
    doc_restriction?: DocRestriction | null;
    doc_types?: string[];
    integration_field_mappings?: CreateIntegrationFieldMappingAttributes[] | null;
    /** Whether the field's attributes may be modified after creation. Defaults to `true` even when `integration_field_mappings` are supplied; pass `false` to lock the field. Settable only at create; `PATCH` does not accept it. */
    is_editable?: boolean | null;
};
export type CreateFieldData = {
    type: string;
    attributes: CreateFieldAttributes;
};
export type CreateFieldRequest = {
    data: CreateFieldData[];
};
export type JsonApiErrorSource = {
    pointer?: string | null;
    parameter?: string | null;
};
export type JsonApiError = {
    /** The HTTP status code applicable to this problem, expressed as a string value. */
    status: string;
    /** An application-specific error code, expressed as a string value (SCREAMING_SNAKE_CASE). */
    code: string;
    /** A short, human-readable summary of the problem. Should not change between occurrences. */
    title: string;
    /** A human-readable explanation specific to this occurrence of the problem. Always populated by the server (required field, never ``null``) so clients can safely render it without a None-guard. */
    detail: string;
    source?: JsonApiErrorSource | null;
    /** Non-standard metadata. Carries ``i18n_key`` (stable translation key) and ``i18n_params`` (scalar interpolation values, all coerced to string by the server so the dict is JSON-stable) when the exception carries an i18n contract; omitted otherwise. */
    meta?: {
        [key: string]: any;
    } | null;
};
export type ValidateFieldResultItem = {
    field_id: string;
    valid: boolean;
    errors?: JsonApiError[] | null;
};
export type ValidateBatchResponse = {
    results: ValidateFieldResultItem[];
};
export type ValidationContext = "user_input" | "system";
export type ValidateFieldItem = {
    field_id: string;
    value: any;
};
export type ValidateBatchRequest = {
    context?: ValidationContext;
    items: ValidateFieldItem[];
};
export type JsonApiResource = {
    type: string;
    id: string;
    attributes: any;
    meta?: ResourceMeta | null;
};
export type JsonApiResponseClientFieldResourceJsonApiResource = {
    data: ClientFieldResource;
    included?: JsonApiResource[] | null;
};
export type UpdateFieldAttributes = {
    custom_name?: string | null;
    description?: string | null;
    data_classification?: DataClassification | null;
    option_set_id?: string | null;
    default_value?: {
        [key: string]: any;
    } | null;
    custom_settings?: {
        [key: string]: any;
    } | null;
    display_settings?: {
        [key: string]: any;
    } | null;
    suggestions_id?: string | null;
    /** Optional suggestion-source config. When present, must include a string ``type`` field; Pilot and the UI interpret the type value. */
    suggestion_source_config?: {
        [key: string]: any;
    } | null;
    /** Restricts which document types the field applies to. Must be set together with doc_types in the same request; the pair is replaced as a unit, never patched independently. */
    doc_restriction?: DocRestriction | null;
    doc_types?: string[];
    is_active?: boolean | null;
};
export type UpdateFieldMeta = {
    /** Current resource version for optimistic locking. */
    version: number;
};
export type UpdateFieldData = {
    type: string;
    attributes: UpdateFieldAttributes;
    meta: UpdateFieldMeta;
};
export type UpdateFieldRequest = {
    data: UpdateFieldData;
};
export type DeleteFieldMeta = {
    /** Current resource version for optimistic locking. */
    version: number;
};
export type DeleteFieldData = {
    type: string;
    meta: DeleteFieldMeta;
};
export type DeleteFieldRequest = {
    data: DeleteFieldData;
};
export type IntegrationFieldMappingResponseAttributes = {
    field_id: string;
    namespace: string;
    integration_key: string;
    domain?: string | null;
};
export type IntegrationFieldMappingResource = {
    type?: "integration_field_mappings";
    id: string;
    attributes: IntegrationFieldMappingResponseAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiResponseIntegrationFieldMappingResourceJsonApiResource = {
    data: IntegrationFieldMappingResource;
    included?: JsonApiResource[] | null;
};
export type AddIntegrationFieldMappingAttributes = {
    /** Integration namespace the key belongs to, e.g. `evisort`. */
    namespace: string;
    /** The integration's own identifier for this field. Unique per `(client, namespace)`: a key resolves to exactly one field, though one field may carry several keys. */
    integration_key: string;
    /** Optional sub-scope within `namespace`. Descriptive only; not part of the mapping's identity. */
    domain?: string | null;
};
export type AddIntegrationFieldMappingData = {
    type?: "integration_field_mappings";
    attributes: AddIntegrationFieldMappingAttributes;
};
export type AddIntegrationFieldMappingRequest = {
    data: AddIntegrationFieldMappingData;
};
export type OptionSetAttributes = {
    logical_type: LogicalType;
    created_at?: string | null;
    updated_at?: string | null;
};
export type OptionSetResource = {
    type?: "option_sets";
    id: string;
    attributes: OptionSetAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiResponseOptionSetResourceJsonApiResource = {
    data: OptionSetResource;
    included?: JsonApiResource[] | null;
};
export type CreateOptionSetAttributes = {
    logical_type: LogicalType;
};
export type CreateOptionSetData = {
    type: string;
    attributes: CreateOptionSetAttributes;
};
export type CreateOptionSetRequest = {
    data: CreateOptionSetData;
};
export type FieldOptionAttributes = {
    value: {
        [key: string]: any;
    };
    display_text?: string | null;
    default?: boolean | null;
};
export type FieldOptionResource = {
    type?: "field_options";
    id: string;
    attributes: FieldOptionAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiPaginatedResponseFieldOptionResourceJsonApiResource = {
    data: FieldOptionResource[];
    included?: JsonApiResource[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type SkippedFieldOptionItem = {
    index: number;
    reason: "duplicate" | "invalid";
    value: {
        [key: string]: any;
    };
    detail?: string | null;
    i18n_key?: string | null;
    i18n_params?: {
        [key: string]: any;
    } | null;
};
export type CreateFieldOptionsMeta = {
    page: PaginationMeta;
    skipped?: SkippedFieldOptionItem[];
};
export type CreateFieldOptionsResponse = {
    data: FieldOptionResource[];
    meta: CreateFieldOptionsMeta;
};
export type CreateFieldOptionAttributes = {
    option_set_id: string;
    value: {
        [key: string]: any;
    };
    default?: boolean;
};
export type CreateFieldOptionData = {
    type: string;
    attributes: CreateFieldOptionAttributes;
};
export type CreateFieldOptionsRequest = {
    data: CreateFieldOptionData[];
};
export type DeleteFieldOptionsRequest = {
    ids: string[];
};
export type JsonApiResponseFieldOptionResourceJsonApiResource = {
    data: FieldOptionResource;
    included?: JsonApiResource[] | null;
};
export type UpdateFieldOptionAttributes = {
    value?: {
        [key: string]: any;
    } | null;
    default?: boolean | null;
};
export type UpdateFieldOptionData = {
    type: string;
    attributes: UpdateFieldOptionAttributes;
};
export type UpdateFieldOptionRequest = {
    data: UpdateFieldOptionData;
};
export type FieldSuggestionAttributes = {
    value: {
        [key: string]: any;
    };
    display_text?: string | null;
};
export type JsonApiResourceFieldSuggestionAttributes = {
    type: string;
    id: string;
    attributes: FieldSuggestionAttributes;
    meta?: ResourceMeta | null;
};
export type FieldSuggestionsMeta = {
    page: PaginationMeta;
    field_id: string;
};
export type FieldSuggestionsResponse = {
    data: JsonApiResourceFieldSuggestionAttributes[];
    meta: FieldSuggestionsMeta;
};
export type FieldSectionRelationships = {
    client_fields: JsonApiRelationship;
};
export type FieldSectionRelatedResource = {
    type?: "field_sections";
    id: string;
    attributes: FieldSectionAttributes;
    meta?: ResourceMeta | null;
    relationships: FieldSectionRelationships;
};
export type JsonApiPaginatedResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource = {
    data: (FieldSectionResource | FieldSectionRelatedResource)[];
    included?: ClientFieldResource[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type JsonApiResponseUnionFieldSectionResourceFieldSectionRelatedResourceClientFieldResource = {
    data: FieldSectionResource | FieldSectionRelatedResource;
    included?: ClientFieldResource[] | null;
};
export type CreateFieldSectionAttributes = {
    name: string;
};
export type CreateFieldSectionData = {
    type?: "field_sections";
    attributes: CreateFieldSectionAttributes;
};
export type CreateFieldSectionRequest = {
    data: CreateFieldSectionData;
};
export type UpdateFieldSectionAttributes = {
    name: string;
};
export type UpdateMeta = {
    /** Current resource version for optimistic locking. */
    version: number;
};
export type UpdateFieldSectionData = {
    type?: "field_sections";
    attributes: UpdateFieldSectionAttributes;
    meta: UpdateMeta;
};
export type UpdateFieldSectionRequest = {
    data: UpdateFieldSectionData;
};
export type DeleteFieldSectionData = {
    type?: "field_sections";
    meta: UpdateMeta;
};
export type DeleteFieldSectionRequest = {
    data: DeleteFieldSectionData;
};
export type ReorderFieldSectionsMoveAttributes = {
    section_id: string;
    before_section_id?: string | null;
};
export type ReorderFieldSectionsMoveData = {
    type?: "field_section_moves";
    attributes: ReorderFieldSectionsMoveAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldSectionsFullAttributes = {
    ordered_section_ids: string[];
};
export type ReorderFieldSectionsFullData = {
    type?: "field_section_orders";
    attributes: ReorderFieldSectionsFullAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldSectionsRequest = {
    data: ({
        type: "field_section_moves";
    } & ReorderFieldSectionsMoveData) | ({
        type: "field_section_orders";
    } & ReorderFieldSectionsFullData);
};
export type FieldSectionFieldAssignmentEntry = {
    field_id: string;
    version: number;
};
export type MoveFieldSectionFieldsAttributes = {
    fields: FieldSectionFieldAssignmentEntry[];
    before_field_id?: string | null;
};
export type MoveFieldSectionFieldsData = {
    type?: "field_section_field_assignments";
    attributes: MoveFieldSectionFieldsAttributes;
};
export type MoveFieldSectionFieldsRequest = {
    data: MoveFieldSectionFieldsData;
};
export type ReorderFieldSectionFieldsMoveAttributes = {
    field_id: string;
    before_field_id?: string | null;
};
export type ReorderFieldSectionFieldsMoveData = {
    type?: "field_section_field_moves";
    attributes: ReorderFieldSectionFieldsMoveAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldSectionFieldsFullAttributes = {
    ordered_field_ids: string[];
};
export type ReorderFieldSectionFieldsFullData = {
    type?: "field_section_field_orders";
    attributes: ReorderFieldSectionFieldsFullAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldSectionFieldsRequest = {
    data: ({
        type: "field_section_field_moves";
    } & ReorderFieldSectionFieldsMoveData) | ({
        type: "field_section_field_orders";
    } & ReorderFieldSectionFieldsFullData);
};
export type FieldLookupTableColumnAttributes = {
    key: string;
    position: number;
    client_field_id: string;
    option_set_id?: string | null;
    label?: string | null;
    logical_type?: string | null;
    is_active?: boolean | null;
    is_reference_column?: boolean;
    required: boolean;
    default_value?: {
        [key: string]: any;
    } | null;
    display_settings?: {
        [key: string]: any;
    };
    created_by?: number | null;
    updated_by?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
};
export type FieldLookupTableColumnRelationships = {
    lookup_table: JsonApiRelationship;
    client_field: JsonApiRelationship;
};
export type FieldLookupTableColumnResource = {
    type?: "field_lookup_table_columns";
    id: string;
    attributes: FieldLookupTableColumnAttributes;
    meta?: ResourceMeta | null;
    relationships: FieldLookupTableColumnRelationships;
};
export type ClientFieldIncludedAttributes = {
    custom_name: string;
    api_name?: string | null;
    logical_type: string;
    option_set_id?: string | null;
    data_classification: string;
    deactivated_at?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
};
export type ClientFieldIncludedRelationships = {
    field_options: JsonApiRelationship;
};
export type ClientFieldIncludedResource = {
    type?: "client_fields";
    id: string;
    attributes: ClientFieldIncludedAttributes;
    meta?: ResourceMeta | null;
    relationships?: ClientFieldIncludedRelationships | null;
};
export type FieldOptionIncludedAttributes = {
    option_set_id: string;
    value: {
        [key: string]: any;
    };
    display_text?: string | null;
    sort_value?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
};
export type FieldOptionIncludedResource = {
    type?: "field_options";
    id: string;
    attributes: FieldOptionIncludedAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiPaginatedResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource = {
    data: FieldLookupTableColumnResource[];
    included?: (ClientFieldIncludedResource | FieldOptionIncludedResource)[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type CreateFieldLookupTableColumnsMeta = {
    field_lookup_table_id: string;
};
export type CreateFieldLookupTableColumnAttributes = {
    key: string;
    client_field_id: string;
    required?: boolean;
    default_value?: {
        [key: string]: any;
    } | null;
    display_settings?: {
        [key: string]: any;
    } | null;
    is_reference_column?: boolean;
};
export type CreateFieldLookupTableColumnData = {
    type: string;
    attributes: CreateFieldLookupTableColumnAttributes;
};
export type CreateFieldLookupTableColumnsRequest = {
    meta: CreateFieldLookupTableColumnsMeta;
    data: CreateFieldLookupTableColumnData[];
};
export type JsonApiResponseFieldLookupTableColumnResourceUnionClientFieldIncludedResourceFieldOptionIncludedResource = {
    data: FieldLookupTableColumnResource;
    included?: (ClientFieldIncludedResource | FieldOptionIncludedResource)[] | null;
};
export type UpdateFieldLookupTableColumnAttributes = {
    required?: boolean | null;
    default_value?: {
        [key: string]: any;
    } | null;
    display_settings?: {
        [key: string]: any;
    } | null;
    is_reference_column?: boolean | null;
};
export type UpdateFieldLookupTableColumnData = {
    type: string;
    attributes: UpdateFieldLookupTableColumnAttributes;
    meta: UpdateMeta;
};
export type UpdateFieldLookupTableColumnRequest = {
    data: UpdateFieldLookupTableColumnData;
};
export type FieldLookupTableRowAttributes = {
    position: number;
    external_key?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
};
export type FieldLookupTableRowRelationships = {
    lookup_table: JsonApiRelationship;
    cells: JsonApiRelationship;
};
export type FieldLookupTableRowResource = {
    type?: "field_lookup_table_rows";
    id: string;
    attributes: FieldLookupTableRowAttributes;
    meta?: ResourceMeta | null;
    relationships: FieldLookupTableRowRelationships;
};
export type FieldLookupTableCellAttributes = {
    column_key?: string | null;
    column_id: string;
    row_id: string;
    value: {
        [key: string]: any;
    };
    display_text?: string | null;
    client_field_id?: string | null;
};
export type FieldLookupTableCellResource = {
    type?: "field_lookup_table_cells";
    id: string;
    attributes: FieldLookupTableCellAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiPaginatedResponseFieldLookupTableRowResourceFieldLookupTableCellResource = {
    data: FieldLookupTableRowResource[];
    included?: FieldLookupTableCellResource[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type FieldLookupTableCellInput = {
    column_key?: string | null;
    column_id?: string | null;
    value: {
        [key: string]: any;
    };
};
export type CreateFieldLookupTableRowAttributes = {
    cells?: FieldLookupTableCellInput[];
    external_key?: string | null;
};
export type CreateFieldLookupTableRowData = {
    type: string;
    attributes: CreateFieldLookupTableRowAttributes;
};
export type CreateFieldLookupTableRowsRequest = {
    data: CreateFieldLookupTableRowData[];
};
export type JsonApiResponseFieldLookupTableRowResourceFieldLookupTableCellResource = {
    data: FieldLookupTableRowResource;
    included?: FieldLookupTableCellResource[] | null;
};
export type UpdateFieldLookupTableRowAttributes = {
    position?: number | null;
    cells?: {
        [key: string]: any;
    } | null;
};
export type UpdateFieldLookupTableRowData = {
    type: string;
    attributes: UpdateFieldLookupTableRowAttributes;
    meta: UpdateMeta;
};
export type UpdateFieldLookupTableRowRequest = {
    data: UpdateFieldLookupTableRowData;
};
export type FieldLookupTableCellRelationships = {
    lookup_table_row: JsonApiRelationship;
    lookup_table_column: JsonApiRelationship;
};
export type FieldLookupTableCellPrimaryResource = {
    type?: "field_lookup_table_cells";
    id: string;
    attributes: FieldLookupTableCellAttributes;
    meta?: ResourceMeta | null;
    relationships: FieldLookupTableCellRelationships;
};
export type JsonApiResponseFieldLookupTableCellPrimaryResourceJsonApiResource = {
    data: FieldLookupTableCellPrimaryResource;
    included?: JsonApiResource[] | null;
};
export type UpdateFieldLookupTableCellAttributes = {
    value: {
        [key: string]: any;
    };
};
export type UpdateFieldLookupTableCellData = {
    type: string;
    attributes: UpdateFieldLookupTableCellAttributes;
    meta: UpdateMeta;
};
export type UpdateFieldLookupTableCellRequest = {
    data: UpdateFieldLookupTableCellData;
};
export type FieldLookupTableAttributes = {
    name: string;
    description?: string | null;
    column_count?: number | null;
    row_count?: number | null;
    created_by?: number | null;
    updated_by?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
};
export type FieldLookupTableResource = {
    type?: "field_lookup_tables";
    id: string;
    attributes: FieldLookupTableAttributes;
    meta?: ResourceMeta | null;
};
export type JsonApiPaginatedResponseFieldLookupTableResourceFieldLookupTableColumnResource = {
    data: FieldLookupTableResource[];
    included?: FieldLookupTableColumnResource[] | null;
    meta: JsonApiListMeta;
    links?: PageLinks | null;
};
export type JsonApiResponseFieldLookupTableResourceJsonApiResource = {
    data: FieldLookupTableResource;
    included?: JsonApiResource[] | null;
};
export type CreateFieldLookupTableAttributes = {
    name: string;
    description?: string | null;
};
export type CreateFieldLookupTableData = {
    type: string;
    attributes: CreateFieldLookupTableAttributes;
};
export type CreateFieldLookupTableRequest = {
    data: CreateFieldLookupTableData;
};
export type UpdateFieldLookupTableAttributes = {
    name?: string | null;
    description?: string | null;
};
export type UpdateFieldLookupTableData = {
    type: string;
    attributes: UpdateFieldLookupTableAttributes;
    meta: UpdateMeta;
};
export type UpdateFieldLookupTableRequest = {
    data: UpdateFieldLookupTableData;
};
export type ReorderFieldLookupTableColumnsMoveAttributes = {
    column_id: string;
    before_column_id?: string | null;
};
export type ReorderFieldLookupTableColumnsMoveData = {
    type?: "field_lookup_table_column_moves";
    attributes: ReorderFieldLookupTableColumnsMoveAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldLookupTableColumnsFullAttributes = {
    ordered_column_ids: string[];
};
export type ReorderFieldLookupTableColumnsFullData = {
    type?: "field_lookup_table_column_orders";
    attributes: ReorderFieldLookupTableColumnsFullAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldLookupTableColumnsRequest = {
    data: ({
        type: "field_lookup_table_column_moves";
    } & ReorderFieldLookupTableColumnsMoveData) | ({
        type: "field_lookup_table_column_orders";
    } & ReorderFieldLookupTableColumnsFullData);
};
export type ReorderFieldLookupTableRowsMoveAttributes = {
    row_id: string;
    before_row_id?: string | null;
};
export type ReorderFieldLookupTableRowsMoveData = {
    type?: "field_lookup_table_row_moves";
    attributes: ReorderFieldLookupTableRowsMoveAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldLookupTableRowsFullAttributes = {
    ordered_row_ids: string[];
};
export type ReorderFieldLookupTableRowsFullData = {
    type?: "field_lookup_table_row_orders";
    attributes: ReorderFieldLookupTableRowsFullAttributes;
    meta: UpdateMeta;
};
export type ReorderFieldLookupTableRowsRequest = {
    data: ({
        type: "field_lookup_table_row_moves";
    } & ReorderFieldLookupTableRowsMoveData) | ({
        type: "field_lookup_table_row_orders";
    } & ReorderFieldLookupTableRowsFullData);
};
export type SkippedFieldLookupTableRowResponse = {
    index: number;
    reason: string;
};
export type BulkUpsertRowsMeta = {
    page: PaginationMeta;
    skipped: SkippedFieldLookupTableRowResponse[];
};
export type BulkUpsertRowsResponse = {
    data: FieldLookupTableRowResource[];
    meta: BulkUpsertRowsMeta;
    included?: FieldLookupTableCellResource[] | null;
};
export type BulkUpsertFieldLookupTableRowItemAttributes = {
    cells?: FieldLookupTableCellInput[];
    external_key?: string | null;
};
export type BulkUpsertFieldLookupTableRowItemData = {
    type: string;
    id?: string | null;
    attributes: BulkUpsertFieldLookupTableRowItemAttributes;
};
export type BulkUpsertFieldLookupTableRowsRequest = {
    data: BulkUpsertFieldLookupTableRowItemData[];
};
